module.exports = __webpack_public_path__ + "img/BF_Logo_Minimal.a65cd1c2.svg";